const messageTypeFieldError   = 'field-error';
const messageTypeFieldSuccess = 'field-success';
const messageTypeFormError    = 'form-error';
const messageTypeFormSuccess  = 'form-success';

function clearStatusMessages() {
  const formStatusMessages = document.querySelector('.action-status-messages');
  const fieldsStatusMessages = document.querySelectorAll('.field-action-status-messages');

  formStatusMessages.innerHTML = '';
  fieldsStatusMessages.forEach((field) => {
    field.innerHTML = '';
  });
}

function getMessageClass(type) {
  const classes = [];
  switch (type) {
    case messageTypeFieldError:
      classes.push('field_error_message');

      break;
    case messageTypeFieldSuccess:
      classes.push('field_success_message');

      break;
    case messageTypeFormError:
      classes.push('alert');
      classes.push('alert_error');

      break;
    case messageTypeFormSuccess:
      classes.push('alert');
      classes.push('alert_success');

      break;
    default:
      classes.push('alert');
      classes.push('alert_error');
  }

  return classes;
}

function getMessageParent(message) {
  let messageParent = null;
  // если сообщение относится к конкретному полю, то ищем родительский элемент в
  // котором далее будем заполнять блок с сообщениями
  if (
    message.messageType === messageTypeFieldError ||
    message.messageType === messageTypeFieldSuccess
  ) {

    const fieldWrapElement = document.querySelector('[data-message-parent-id="' + message.parentId + '"]');

    if (!fieldWrapElement) {
      return null;
    }

    messageParent = fieldWrapElement.querySelector('.field-action-status-messages');
    // если тип сообщения относится к форме, а не конкретному полю, то
    // выводим сообщение над формой в блоке для сообщений
  } else if (
    message.messageType === messageTypeFormError ||
    message.messageType === messageTypeFormSuccess
  ) {
    messageParent = document.querySelector('.action-status-messages');

    if (!messageParent) {
      return null;
    }
  }

  return messageParent;
}

function normalizeMessage(message) {
  if (typeof message === 'string') {
    return {
      messageType: messageTypeFormError,
      content: message,
    };
  }

  if (!message || typeof message !== 'object') {
    return null;
  }

  if (!message.messageType) {
    return {
      ...message,
      messageType: messageTypeFormError,
      content: message.content || 'Возникла ошибка. Пожалуйста обратитесь в техподдержку.',
    };
  }

  return message;
}

function createMessageElement(message) {
  const messageElement = document.createElement('div');

  const classes = getMessageClass(message.messageType);
  classes.forEach((messageClass) => {
    messageElement.classList.add(messageClass);
  });

  let content = 'Возникла ошибка. Пожалуйста обратитесь в техподдержку.';

  if (message.content?.length) {
    content = message.content;
  }

  messageElement.innerHTML = content;

  return messageElement;
}

function showFormResponse(data) {
  let messages;
  let parsedFromText = false;

  if (data?.status && Array.isArray(data.messages)) {
    messages = data.messages;
  }

  if (!messages?.length && typeof data?.responseText === 'string' && data.responseText.length) {
    try {
      const response = JSON.parse(data.responseText);
      if (Array.isArray(response.messages)) {
        messages = response.messages;
        parsedFromText = true;
      } else if (response.status === 'error' && response.message) {
        messages = [response.message];
        parsedFromText = true;
      }
    } catch (error) {
      // handled below
    }
  }

  if (!messages?.length && !parsedFromText && !data?.responseText?.length) {
    return;
  }

  const formTopMessages = document.querySelector('.action-status-messages');

  if (formTopMessages) {
    formTopMessages.innerHTML = '';
  }

  const formTopSessionSuccessMessages = document.querySelectorAll('.alert.alert_success');
  formTopSessionSuccessMessages.forEach((messageWrapper) => {
    messageWrapper.remove();
  });

  const fieldMessages = document.querySelectorAll('.field-action-status-messages');
  fieldMessages.forEach((messageWrapper) => {
    messageWrapper.innerHTML = '';
  });

  const requiredConsentMessages = document.querySelectorAll('.required-consent-error');
  requiredConsentMessages.forEach((messageWrapper) => {
    messageWrapper.style.display = 'none';
  });

  if (!messages?.length && data.responseText?.length) {
    if (formTopMessages) {
      const messageElement = createMessageElement({
        messageType: messageTypeFormError,
        content: 'Не удалось сохранить данные. Попробуйте ещё раз.',
      });
      formTopMessages.appendChild(messageElement);
      formTopMessages.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    return;
  }

  if (!messages?.length) {
    return;
  }

  let renderedCount = 0;
  let firstRenderedElement = null;

  messages.forEach((rawMessage) => {
    const normalizedMessage = normalizeMessage(rawMessage);

    if (!normalizedMessage) {
      return;
    }

    let displayMessage = normalizedMessage;
    let messageParent = getMessageParent(displayMessage);

    if (!messageParent && formTopMessages) {
      displayMessage = {
        messageType: messageTypeFormError,
        content: displayMessage.content || 'Возникла ошибка. Пожалуйста обратитесь в техподдержку.',
      };
      messageParent = formTopMessages;
    }

    if (!messageParent) {
      return;
    }

    const messageElement = createMessageElement(displayMessage);
    messageParent.appendChild(messageElement);
    renderedCount += 1;

    if (!firstRenderedElement) {
      firstRenderedElement = messageElement;
    }
  });

  if (firstRenderedElement) {
    firstRenderedElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
  } else if (renderedCount === 0 && formTopMessages) {
    const messageElement = createMessageElement({
      messageType: messageTypeFormError,
      content: 'Не удалось сохранить данные. Проверьте обязательные поля.',
    });
    formTopMessages.appendChild(messageElement);
    formTopMessages.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

export {showFormResponse, getMessageParent, getMessageClass, clearStatusMessages};
